// Recovered compiled webpack factory 4853. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      cancelIdleCallback: function () {
        return n;
      },
      requestIdleCallback: function () {
        return r;
      },
    }));
  let r =
      ("undefined" != typeof self &&
        self.requestIdleCallback &&
        self.requestIdleCallback.bind(window)) ||
      function (e) {
        let t = Date.now();
        return self.setTimeout(function () {
          e({
            didTimeout: !1,
            timeRemaining: function () {
              return Math.max(0, 50 - (Date.now() - t));
            },
          });
        }, 1);
      },
    n =
      ("undefined" != typeof self &&
        self.cancelIdleCallback &&
        self.cancelIdleCallback.bind(window)) ||
      function (e) {
        return clearTimeout(e);
      };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
